import { AlarmClock } from "lucide-react";
import { WhatsAppNotifyButton } from "@/components/WhatsAppNotifyButton";
import { usePickupTemplate } from "@/hooks/usePickupTemplate";
import { brl, fmtDate } from "@/lib/api";
import { daysWaiting } from "@/lib/store";

export function OverduePickupPanel({ orders, days, onReminded }) {
  const { reminder_message: template } = usePickupTemplate();

  return (
    <div className="rounded-md border border-red-200 bg-white p-6" data-testid="overdue-pickup-panel">
      <h2 className="mb-1 flex items-center gap-2 font-display text-lg font-bold">
        <AlarmClock className="h-5 w-5 text-red-500" /> Esperando retirada há mais de {days} dias
        <span className="rounded-full bg-red-100 px-2 text-xs text-red-700" data-testid="overdue-count">{orders.length}</span>
      </h2>
      <p className="mb-4 text-sm text-slate-500">Pedidos prontos que o cliente ainda não buscou.</p>
      {orders.length === 0 ? (
        <p className="text-sm text-slate-400" data-testid="no-overdue">Nenhum pedido atrasado para retirada.</p>
      ) : (
        <ul className="divide-y divide-slate-100" data-testid="overdue-list">
          {orders.map((o) => (
            <li key={o.id} className="flex flex-wrap items-center justify-between gap-3 py-3" data-testid={`overdue-${o.number}`}>
              <div>
                <p className="font-semibold">
                  {o.customer.name} <span className="font-mono text-xs text-slate-400">#{o.number}</span>
                  <span className="ml-2 rounded-full bg-red-50 px-2 py-0.5 text-xs font-bold text-red-700" data-testid={`overdue-days-${o.number}`}>{daysWaiting(o)} dias</span>
                </p>
                <p className="text-xs text-slate-500">
                  {o.customer.phone} · {brl(o.total)} · {o.reminded_at ? `Último lembrete: ${fmtDate(o.reminded_at)}` : "Nenhum lembrete enviado"}
                </p>
              </div>
              <WhatsAppNotifyButton order={o} template={template} onNotified={onReminded} kind="remind" compact testId={`btn-remind-${o.number}`} />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
